import { render, staticRenderFns } from "./StudyQuizQuestionSelfManagement.vue?vue&type=template&id=6e4efa40"
import script from "./StudyQuizQuestionSelfManagement.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionSelfManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports